import { NOTIFICATIONS_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const fetchNotifications = async () => {
  const res = await axios.get(NOTIFICATIONS_ENDPOINT);
  return res.data;
};

export const markAsClosed = async (notificationId: number) => {
  const res = await axios.post(`${NOTIFICATIONS_ENDPOINT}/${notificationId}`);
  return res.data;
};
